module.exports = __webpack_public_path__ + "img/030cb123ba40d06217040b3f06b6dbb0.jpg";